import {createErrorAction} from './utils';

const TYPES = {
    GET_TOP_10_GAMES: 'GET_TOP_10_GAMES',
    GET_TOP_10_GAMES_COMPLETE: 'GET_TOP_10_GAMES_COMPLETE',
    GET_TOP_10_GAMES_FAILED: 'GET_TOP_10_GAMES_FAILED'
};

export default {
    TYPES,

    getMyTop10Games: payload => ({
        type: TYPES.GET_TOP_10_GAMES,
        payload
    }),

    getMyTop10GamesSuccess: payload => ({
        type: TYPES.GET_TOP_10_GAMES_COMPLETE,
        payload
    }),

    getMyTop10GamesFailed: createErrorAction(TYPES.GET_TOP_10_GAMES_FAILED)
};
